import styled from 'styled-components';
import * as fonts from 'view/styles/fonts';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

// eslint-disable-next-line rulesdir/no-styled-export
export const Container = styled.div`
    ${fonts.small};
    margin-top: ${token('space.050', '4px')};
    color: ${token('color.text.danger', colors.R500)};
    display: flex;
`;
